<template>
  <div class="event-page">
    <div class="tab-bar">
      <button 
        v-for="(_, tab) in tabs" 
        :key="tab"
        :class="['tab-btn', { active: currentTab === tab }]"
        @click="currentTab = tab"
      >
        {{ tabLabels[tab] || tab }}
      </button>
    </div>
    <div class="tab-content">
      <component :is="tabs[currentTab]" class="tab"></component>
    </div>
  </div>
</template>
<script>
import AddEvent from '../components/AddEvent.vue'
import IncomeEvent from '../components/IncomeEvent.vue'
import TransferEvent from '../components/TransferEvent.vue'

export default {
  data() {
    return {
      currentTab: '流水帳',
      tabs: { '流水帳': AddEvent, '轉帳': TransferEvent, '收入': IncomeEvent },
      tabLabels: { '流水帳': '✏️ 流水帳', '轉帳': '🔄 轉帳', '收入': '💵 收入' }
    }
  },
  components: { AddEvent, TransferEvent, IncomeEvent }
}
</script>
<style scoped>
.event-page { max-width: 520px; margin: 0 auto; }
.tab-bar {
  display: flex;
  gap: 4px;
  background: var(--card);
  border-radius: var(--radius);
  box-shadow: var(--shadow);
  padding: 4px;
  margin-bottom: 16px;
}
.tab-btn {
  flex: 1;
  padding: 10px 0;
  font-size: 14px;
  font-weight: 600;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  background: transparent;
  color: var(--text-light);
  transition: all 0.15s;
}
.tab-btn:hover { color: var(--primary); background: #eef2ff; }
.tab-btn.active { background: var(--primary); color: #fff; }
.tab-content {
  background: var(--card);
  border-radius: var(--radius);
  box-shadow: var(--shadow);
  padding: 24px;
}
</style>
